var module = angular.module('octopusApp.environments');

module.directive('cloudRegionEndpoint', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            endpoint: '='
        },
        templateUrl: 'areas/environments/views/endpoints/cloud_region_endpoint.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/cloud_region_endpoint.js
// module id = 6077817072184712
// module chunks = 1